/**
 * AppShell — what sits beside every route, inside the router: global keyboard shortcuts, the help
 * button, and the one-time hand-off of a brand-new club owner to the full-page setup screen.
 *
 * KAN-118: this used to also mount two full-screen "Welcome to Kantera" pop-up wizards, on every
 * route and for every role. Both are gone; a new owner is sent to /setup instead (see
 * useOwnerSetupRedirect for who, when and from where). Nothing here draws over a page.
 */

import React from 'react';
import { HelpButton } from './HelpButton';
import { useAuth } from '../hooks/useAuth';
import { useKeyboardShortcuts } from '../hooks/useKeyboardShortcuts';
import { useOwnerSetupRedirect } from '../hooks/useOwnerSetupRedirect';

export const AppShell: React.FC = () => {
  const { user } = useAuth();

  // Global keyboard shortcuts — active for authenticated users only
  useKeyboardShortcuts();
  useOwnerSetupRedirect();

  return user ? <HelpButton /> : null;
};
